const rrweb = require('rrweb'); // eslint-disable-line import/no-extraneous-dependencies
const {
  SESSION_REPLAY,
  CUSTOM_ATTRIBUTES,
  SESSION_REPLAY_START,
  SESSION_REPLAY_STOP,
  TRACEABILITY_ID,
} = require('../../constants/metrics');
const { RRWEB_EVENT_TYPES } = require('../../constants/session-replay');
const { monitor: recordEvent } = require('./session-replay');
const buildMetadata = require('../builder/session-replay');
const { getMetricsCollected, trackMetric } = require('../collector');
const { objectOperator } = require('../utils/spread');
const { subscribe } = require('../subscriptions');

let rrwebInstance = null;

// eslint-disable-next-line camelcase
const startRecording = (attributes = {}, traceability_id = null) => {
  // eslint-disable-next-line camelcase
  if (traceability_id) {
    trackMetric(TRACEABILITY_ID, traceability_id);
  }

  if (Object.keys(attributes).length) {
    trackMetric(CUSTOM_ATTRIBUTES, attributes);
  }

  /* istanbul ignore next */
  rrwebInstance = rrweb.record({
    emit: (event) => {
      // @see: https://github.com/rrweb-io/rrweb/blob/master/packages/types/src/index.ts#L8
      // EventType.Meta
      if (event.type === RRWEB_EVENT_TYPES.Meta) {
        const metadata = buildMetadata(null, getMetricsCollected());
        event.data = objectOperator([{}, metadata.data, event.data]);
      }

      recordEvent(SESSION_REPLAY, event);
    },
    inlineStylesheet: true,
    recordCanvas: true,
    recordCrossOriginIframes: false,
    maskTextClass: /(ml-mask|rr-mask|nav-header-username|user-badge-title|payment-card-component)/,
    blockClass: /(ml-block|rr-block)/,
    maskInputOptions: {
      date: true,
      'datetime-local': true,
      email: true,
      month: true,
      number: true,
      range: true,
      search: true,
      tel: true,
      text: true,
      time: true,
      url: true,
      week: true,
      textarea: true,
      select: true,
      password: true,
    },
  });
};

const stopRecording = () => rrwebInstance && rrwebInstance();

/**
 * @description This function is responsible for recording the user's session.
  <Script>
  {`
    const agentKey = '_perfill';
    window[agentKey] = window[agentKey] || function (...args) {
      (window[agentKey].q = window[agentKey].q || []).push(args);
    };

    const perfillAgent = window[agentKey];

    perfillAgent('queue', 'start-recording', {
      metadata: { page: 'landing' },
      traceability_id: '1234',
    });
  `}
  </Script>
 */

const sessionRecorder = () => {
  subscribe(SESSION_REPLAY_START, (data = {}) => {
    startRecording((data.metadata || {}), (data.traceability_id || null));
  });

  subscribe(SESSION_REPLAY_STOP, () => {
    stopRecording();
  });

  // eslint-disable-next-line camelcase
  window.startRecording = (attributes = {}, traceability_id = null) => startRecording(attributes, traceability_id);

  window.stopRecording = () => stopRecording();
};

module.exports = sessionRecorder;
